var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileSettingsInner.jinja');
require('./MemberProfileSettingsInner.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click input[name="private"]': 'changePrivate',
        'click .MemberProfileSettingsInner-btnPassword': 'changePassword',
        'change input[type="radio"]': 'onRadioChange'
    },

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    changePrivate: function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $item = $(e.currentTarget);

        if ($item.hasClass('active')) return;

        var visibility = $item.attr('id');

        window.app.vent.trigger('MemberProfileEdit--open', 'private', visibility);
    },

    changePassword: function () {
        window.app.vent.trigger('MemberProfileEdit--open', 'password');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileSettingsInner.js
// module id = 69
// module chunks = 0